/**
 * Brand constants — single source for user-visible UI copy.
 * Does not change API paths, hostnames, or tenant usernames.
 */

/** Primary product name (normative). */
export const BRAND_PRODUCT = "Croc Sentinel";

/**
 * Hero wordmark (login aside + sidebar).
 * Replaces legacy "E.secure" — reads as the product, not a vendor fragment.
 */
export const BRAND_WORDMARK = "SENTINEL";

/**
 * Brand hero wordmark HTML.
 * @returns {string} HTML
 */
export function brandWordmarkStackHtml() {
  return `<p class="auth-surface__wordmark" translate="no" lang="en" title="${BRAND_PRODUCT}" aria-label="${BRAND_PRODUCT}">${BRAND_WORDMARK}</p>`;
}

/** Fleet console series name (secondary line where needed). */
export const BRAND_SERIES = "Croc Sentinel";

export const BRAND_SERIES_ROLE = "edge response console";

/** Short grand tagline — Command Center header / compact chrome. */
export const BRAND_TAGLINE = "Edge truth. Human authority. Enduring proof.";

/** Longer line — auth aside / marketing lede. */
export const BRAND_COMPANY_EYEBROW = "Incident response at the edge";

export const BRAND_COMPANY_LINE =
  "From the first signed signal to the last accountable act.";

export const BRAND_FOOTER_LEGAL = "Croc Sentinel";

/** Canonical mark — crocodile + orbital emblem. */
export const BRAND_LOGO_SRC = "assets/croc-sentinel-logo.png?v=2";

export const BRAND_LOGO_ALT = BRAND_PRODUCT;

export const BRAND_OTA_ZONE_EYEBROW = "SENTINEL secure zone";

export const BRAND_OTA_UNLOCK_PLACEHOLDER = "Contact your Croc Sentinel operator for device credentials";

export const BRAND_HARDWARE_MANUFACTURER = BRAND_PRODUCT;
